import { render } from "./DepartmentModal.vue?vue&type=template&id=c144a84c"
import script from "./DepartmentModal.vue?vue&type=script&lang=js"
export * from "./DepartmentModal.vue?vue&type=script&lang=js"

import "./DepartmentModal.vue?vue&type=style&index=0&id=c144a84c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__